module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/arrow-left-de14eb34d553009fc75104d9e6f70a3b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/arrow-left.svg
// module id = 5dgg
// module chunks = 24